// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container } from '../../components/Elemental'
import _ from 'lodash'
import { Search as SearchIcon } from 'react-feather'

// CSS
import './styles.scss'

// Component
import SearchFilter from "./components/SearchFilter"
import SearchList from "./components/SearchList"
import SearchListHeader from './components/SearchListHeader'
import SearchLoading from "./components/SearchLoading"
import CloseIcon from "../../components/CloseIcon"

// Actions
import { toggleSearch, toggleSearchField, changeSearchValue, changeSearchFields, changeSearchResults, changeSearchPagination, search } from './actions'

class Search extends Component {
  componentDidUpdate(prevProps) {
    const { visible, value, fields, search } = this.props
    const prevVisible = prevProps.visible
    const prevValue = prevProps.value
    const prevFields = prevProps.fields
    const { searchBarInput, searchModal, onScroll } = this

    if (visible && !prevVisible) {
      searchBarInput.focus()
      document.body.style.overflow = "hidden"
      searchModal.addEventListener("scroll", onScroll);
    }

    if ((value !== prevValue) || !_.isEqual(fields, prevFields)) {
      search(value, 0, 15, fields)
    }
  }

  closeSearch = () => {
    const { visible, toggleSearch, changeSearchValue, changeSearchFields, changeSearchResults, changeSearchPagination } = this.props
    const { searchModal, onScroll } = this

    if (visible) {
      document.body.style.overflow = "initial"
      searchModal.removeEventListener("scroll", onScroll);

      toggleSearch()
      changeSearchValue('')
      changeSearchFields([])
      changeSearchResults([], 0)
      changeSearchPagination({ total: 0, from: 0, size: 15 })
    }
  }

  onScroll = (e) => {
    const { value, fields, pagination: { total, from, size }, search } = this.props
    const target = e.target
    const scrollTop = target.scrollTop
    const scrollHeight = target.scrollHeight
    const clientHeight = target.clientHeight
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom && total > (from + size)) {
      search(value, from, size, fields)
    }
  }

  render() {
    const { visible, loading, loadingMore, fields, value, pagination: { total }, results, toggleSearch, toggleSearchField, changeSearchValue } = this.props
    const { closeSearch } = this

    return (
      <div className="search">
        <div className="search__button" onClick={toggleSearch}>
          <SearchIcon size="20" />
        </div>
        <div
          className={visible ? "search__modal search__modal--visible" : "search__modal"}
          onKeyDown={e => e.keyCode === 27 && closeSearch()}
          ref={elem => this.searchModal = elem}
          tabIndex="0">
          <Container>
            <div className="search__bar">
              <input
                value={value}
                onChange={e => changeSearchValue(e.target.value)}
                ref={input => { this.searchBarInput = input; }}
                placeholder="O que você está procurando" />
              <div className="search__close">
                <i className="material-icons" onClick={closeSearch}>close</i>
              </div>
            </div>
            <p className="search__response">Resultados <span>{total} encontrados</span></p>
            <SearchFilter fields={fields} onClick={toggleSearchField} />
            {(!loading || loadingMore) && !_.isEmpty(results) &&
              <SearchListHeader />
            }
            {(!loading || loadingMore) && !_.isEmpty(results) && results.map(result => (
              <SearchList key={result._id} source={result._source} onClick={closeSearch} />
            ))}
            {!loading && _.isEmpty(results) && !value &&
              <div className="search__wrapper">
                Dica: Escreva a UF e filtre por "Processo" para realizar uma busca por estado.<span>
                  Ex: MG
                </span></div>
            }
            {!loading && _.isEmpty(results) && value &&
              <div className="search__wrapper">Não foi possivel encontrar nenhum resultado com:<span>
                {value}
              </span></div>
            }
            {(loading || loadingMore) &&
              <div className={loading ? "search__wrapper" : "search__wrapper search__wrapper--smaller"}>
                <SearchLoading />
              </div>
            }
          </Container>
        </div>
      </div>
    )
  }
}

Search = connect(state => {
  return {
    visible: state.search.visible,
    loading: state.search.loading,
    loadingMore: state.search.loadingMore,
    value: state.search.value,
    fields: state.search.fields,
    results: state.search.results,
    pagination: state.search.pagination
  }
}, { toggleSearch, toggleSearchField, changeSearchValue, changeSearchFields, changeSearchResults, changeSearchPagination, search })(Search)

export default Search
